import axios from 'axios'

async function generate_test(setOpen,setMessage,data,token,setQuestions,setGenerating,setIsGenerated){

    setGenerating(true)

    const generateTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}generate-test/`,data,{
        headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${token}`
            }
    }).catch(err=>{
        console.log(err)
        setGenerating(false)
        setMessage("error...check your connection")
        setOpen(true)
    })

    if (generateTest?.status == 200 && generateTest?.data?.success) {

        setQuestions(generateTest?.data?.test?.test)
        setIsGenerated(true)
        setMessage("the assessment has been generated")
        setOpen(true)
        setGenerating(false)

    }else{
        setMessage(generateTest?.data?.message)
        setOpen(true)
        setGenerating(false)
    }

}

export default generate_test